// Pasos para configurar Notificaciones
// Importar Libreria @capacitor/push-notifications
// Crear metodo registerPush para agregar los Listener de PushNotifications
// Crear metodo publico initPush que llame a registerPush para generar token
// desde initializeApp en app.component.ts llamar a initPush
// Almacenar token en local storage

import { Injectable } from '@angular/core';
// import {
//     Plugins,
//     PushNotification,
//     PushNotificationToken,
//     PushNotificationActionPerformed,
//     Capacitor
// } from '@capacitor/core';

import { PushNotifications } from '@capacitor/push-notifications';

import { Router } from '@angular/router';
import { ApiData } from '../../providers/api';

// const { Storage } = Plugins;
// import { Storage } from '@ionic/storage-angular';
import { Storage } from '@ionic/storage';
// import { Capacitor } from '@capacitor/core';
import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';

// const { PushNotifications } = Plugins;

@Injectable({
  providedIn: 'root'
})
export class FcmService {

  plataformaActual: string;

  constructor(public router: Router,public platform: Platform, public storage: Storage) {

  }



  public initPush() {
    // if (Capacitor.platform !== 'web') {
    //   this.registerPush();
    // }
    this.storage.create();
    console.log("initPush Create Storage: ",this.storage)
    console.log('Platform',this.platform.platforms()[0])
    if (this.platform.platforms()[0] !== 'web') {
      this.registerPush();
    }
  }

  private registerPush() {
    PushNotifications.requestPermissions().then((permission) => {
      if (permission.receive !== "granted" ) {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // No permission for push granted
      }
    });

    PushNotifications.addListener('registration', async (token) => {
        console.log('Mi token desde registration: ' + JSON.stringify(token));
        await this.storage.set('token',token.value);
      }
    );

    PushNotifications.addListener('registrationError', (error: any) => {
      console.log('Error: ' + JSON.stringify(error));
    });

    PushNotifications.addListener('pushNotificationReceived', async (notification) => {
        console.log('Push received: ' + JSON.stringify(notification));
      }
    );

    PushNotifications.addListener('pushNotificationActionPerformed', async (notification) => {
        const data = notification.notification.data;
        console.log('Action performed: ' + JSON.stringify(notification.notification));
        if (data.detailsId) {
          this.router.navigateByUrl('/home/${data.detailsId}');
        }
      }
    );
  }
}

export async function get_token(): Promise<any> {

  const value = await this.storage.get({ key: 'token' })

  // const value = await this.storage({ key: 'token' })
  console.log('token desde get_token() : ', value)
  return value.value
}
